/**
 * Frequently bought together — totals and add-stack.
 */
(function () {
  var CART_ADD_URL = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  var CART_URL = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
  var CART_CHANGE_URL = (window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js';

  function money(cents) {
    return '£' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function jsonXhr(method, url, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/javascript');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch (error) {
            reject(error);
          }
        } else {
          reject(new Error(xhr.status));
        }
      };
      xhr.onerror = function () {
        reject(new Error('network'));
      };
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  function qtyByVariant(cart) {
    var map = {};
    (cart.items || []).forEach(function (line) {
      map[line.variant_id] = (map[line.variant_id] || 0) + line.quantity;
    });
    return map;
  }

  function selectedItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-gs-fbt-item]:checked'));
  }

  function updateTotals(root) {
    var items = selectedItems(root);
    var percent = Number(root.getAttribute('data-stack-percent') || 0);
    var sum = items.reduce(function (total, input) {
      return total + (Number(input.getAttribute('data-price')) || 0);
    }, 0);
    var stack = items.reduce(function (total, input) {
      var price = Number(input.getAttribute('data-price')) || 0;
      if (items.length >= 2 && percent > 0) {
        return total + (price - Math.floor(price * percent / 100));
      }
      return total + price;
    }, 0);
    var stackEl = root.querySelector('[data-gs-fbt-stack]');
    var sumEl = root.querySelector('[data-gs-fbt-sum]');
    var addBtn = root.querySelector('[data-gs-fbt-add]');
    var countEl = root.querySelector('[data-gs-fbt-count]');
    if (stackEl) stackEl.textContent = money(stack);
    if (sumEl) {
      sumEl.textContent = money(sum);
      sumEl.hidden = items.length < 2 || stack === sum;
    }
    if (countEl) {
      countEl.textContent = items.length === 1 ? 'Total for this item' : 'Total for ' + items.length + ' items';
    }
    if (addBtn) {
      addBtn.disabled = items.length === 0;
      addBtn.textContent = items.length <= 1 ? 'Add item' : 'Add ' + items.length + ' items';
    }
    root.querySelectorAll('[data-gs-fbt-item]').forEach(function (input) {
      var item = input.closest('.gs-fbt__item');
      if (item) item.classList.toggle('is-off', !input.checked);
    });
  }

  function normalizeQuantities(before, intended, sections) {
    return jsonXhr('GET', CART_URL).then(function (cart) {
      var after = qtyByVariant(cart);
      var chain = Promise.resolve(cart);
      intended.forEach(function (item) {
        var desired = (before[item.id] || 0) + item.quantity;
        if ((after[item.id] || 0) !== desired) {
          chain = chain.then(function () {
            return jsonXhr('POST', CART_CHANGE_URL, {
              id: String(item.id),
              quantity: desired,
              sections: sections,
              sections_url: window.location.pathname
            });
          });
        }
      });
      return chain;
    });
  }

  function addStack(root) {
    var items = selectedItems(root).map(function (input) {
      return { id: Number(input.getAttribute('data-variant-id')), quantity: 1 };
    }).filter(function (item) {
      return item.id;
    });
    if (!items.length) return Promise.resolve();

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = 'cart-icon-bubble';
    if (cartDrawer) {
      var section = cartDrawer.closest('.shopify-section');
      if (section) sections += ',' + section.id.replace('shopify-section-', '');
    }

    var addBtn = root.querySelector('[data-gs-fbt-add]');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
    }

    return jsonXhr('GET', CART_URL).then(function (cart) {
      var before = qtyByVariant(cart);
      return jsonXhr('POST', CART_ADD_URL, {
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      }).then(function (data) {
        return normalizeQuantities(before, items, sections).then(function (normalized) {
          return normalized || data;
        });
      });
    }).then(function (data) {
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data, true);
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      }
    }).catch(function () {
      window.location.href = '/cart';
    }).finally(function () {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      }
    });
  }

  function desktopMq() {
    return window.matchMedia('(min-width: 990px)');
  }

  function alignOperators(root) {
    var ops = root.querySelectorAll('.gs-fbt__op');
    var footer = root.querySelector('.gs-fbt__footer');
    if (!desktopMq().matches) {
      ops.forEach(function (op) {
        op.style.height = '';
      });
      if (footer) footer.style.marginTop = '';
      return;
    }
    var media = root.querySelector('.gs-fbt__item .card__media');
    var height = media ? Math.round(media.getBoundingClientRect().height) : 0;
    ops.forEach(function (op) {
      op.style.height = height > 0 ? height + 'px' : '';
    });
    if (footer && height > 0 && !root.closest('.gs-fbt-under-media')) {
      var footerHeight = Math.round(footer.getBoundingClientRect().height);
      footer.style.marginTop = Math.max(0, Math.round((height - footerHeight) / 2)) + 'px';
    }
  }

  function bind(root) {
    if (!root || root.dataset.gsFbtReady) return;
    root.dataset.gsFbtReady = '1';
    root.addEventListener('change', function (event) {
      if (event.target && event.target.hasAttribute('data-gs-fbt-item')) updateTotals(root);
    });
    var addBtn = root.querySelector('[data-gs-fbt-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addStack(root);
      });
    }
    document.addEventListener('on:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var current = root.querySelector('[data-gs-fbt-item][data-current="true"]');
      if (!current) return;
      current.setAttribute('data-variant-id', variant.id);
      current.setAttribute('data-price', variant.price);
      var item = current.closest('.gs-fbt__item');
      var priceEl = item && item.querySelector('.price__current, [data-gs-fbt-price]');
      if (priceEl) priceEl.textContent = money(variant.price);
      updateTotals(root);
    });
    updateTotals(root);
    alignOperators(root);
    var mediaEls = root.querySelectorAll('.gs-fbt__item .card__media img');
    mediaEls.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        alignOperators(root);
      }, { once: true });
    });
    var resizeTimer;
    var mq = desktopMq();
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        alignOperators(root);
      }, 120);
    });
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        alignOperators(root);
      });
    } else if (mq.addListener) {
      mq.addListener(function () {
        alignOperators(root);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-gs-fbt]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
